//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from 'quasar'

import Vue2DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/ru'

export default {
  name: 'DateIntervalField',
  components: {
    Vue2DatePicker
  },
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: Object,
      required: true
    },
    clearable: {
      type: Boolean,
      default: false
    },
    labelColor: {
      type: String,
      default: undefined
    },
    notDense: {
      type: Boolean,
      default: false
    },
    noYear: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    },
    rules: {
      type: Array,
      default: undefined
    },
    disabledDate: {
      type: Function,
      default: () => false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      intervalConfig: null,
      pickerObserver: null,
      ignoreFieldClick: false,
      empty: false
    }
  },
  computed: {
    formatDate: function () {
      if (this.noYear) {
        return 'DD.MM'
      } else {
        return 'DD.MM.YYYY'
      }
    },
    pickerValue: function () {
      return this.intervalConfig && this.intervalConfig.start != null && this.intervalConfig.end ? [new Date(this.intervalConfig.start), new Date(this.intervalConfig.end)] : [null, null]
    }
  },
  watch: {
    value: {
      handler: function (interval) {
        // console.log('value', interval)
        this.setIntervalConfig(interval)
      },
      immediate: true
    }
  },
  beforeDestroy: function () {
    if (this.pickerObserver) {
      this.pickerObserver.disconnect()
    }
  },
  methods: {
    formatMillis: function (millis) {
      if (millis) {
        return date.formatDate(millis, this.formatDate)
      }
      return null
    },
    parseDate (value) {
      return date.extractDate(value, this.formatDate)
    },
    parseMillis (value) {
      let millis = this.parseDate(value).getTime()

      // Если год не отображается, для сервера нужно скорректировать миллисекунды (как будто год есть)
      if (this.noYear) {
        const currentYear = new Date().getFullYear()
        millis = new Date(millis).setFullYear(currentYear)
      }
      return millis
    },
    setIntervalConfig: function (interval) {
      if (interval && interval.start != null && interval.end != null) {
        this.intervalConfig = { start: interval.start, end: interval.end - 86400000 }
        this.empty = false
      } else {
        this.intervalConfig = { start: null, end: null }
        this.empty = true
      }
    },

    onFieldClick: function (event) {
      if (this.readonly) {
        return
      }

      if (event.target.className !== 'mx-input' && !event.ignoreShowPicker) {
        const picker = this.$refs.datePicker
        picker.openPopup()
      }
    },
    onInput: function (pickerValue) {
      // console.log('input', pickerValue)

      const startDate = pickerValue[0]
      const endDate = pickerValue[1]
      if ((startDate != null && endDate != null) || (startDate == null && endDate == null)) {
        this.intervalConfig.start = startDate != null ? startDate.getTime() : null
        this.intervalConfig.end = endDate != null ? endDate.getTime() : null
        this.emitValue()
      }
    },
    isIntervalValid: function (interval = this.intervalConfig) {
      return (interval.start != null && interval.end != null) || (interval.start == null && interval.end == null)
    },
    onClear: function () {
      this.emitValue(null)
      this.$emit('clear')
    },
    emitValue: function (intervalConfig = this.intervalConfig) {
      if (intervalConfig && intervalConfig.start != null && intervalConfig.end != null) {
        this.$emit('input', {
          start: intervalConfig.start,
          end: intervalConfig.end + 86400000
        })
      } else {
        this.$emit('input', { start: null, end: null })
      }
    },
    validate: function () {
      return this.$refs.field.validate()
    }
  }
}
